export function allowCharacter(character) {
    const keysForbidden = ['#', '?', '*', '{', '}', '[', ']', '(', ')', '~', '^', '$', '\\', '!', ' | ', '=', ' < ', ' >'];
    return keysForbidden.indexOf(character) === -1;
}